<template>
    <div>
        <v-form ref="formData" class="form-data" @submit.prevent="onSubmit()">
            <v-app-bar flat color="white" height="72" fixed app>
                <!-- Start Navigation Back to User Access -->
                <router-link to="/user-access" style="text-decoration: none; color: inherit">
                    <v-icon left x-large class="pa-4"> mdi-arrow-left </v-icon>
                </router-link>
                <!-- End Navigation Back to User Access -->

                <!-- Start Upper Left Label -->
                <h2 class="d-flex align-center">
                    <span v-if="action == 'create'">Create User</span>
                    <span v-if="action == 'invite-user'">Invite User</span>
                    <span v-if="action == 'edit'">Edit User</span>
                    <span v-if="action == 'view'">{{ form.full_name }}</span>
                    <!-- <small :class="['mx-4 px-2 py-1 px-4 font-weight-medium status', form.status.toLowerCase()]" v-if="action == 'view'">{{ form.status | uppercaseFirst }}</small> -->
                </h2>
                <!-- End Upper Left Label -->

                <!-- Start Upper Right Btns -->
                <v-card flat class="ml-auto">
                    <v-btn class="mx-1" @click="editDetails()" outlined text v-if="isView">
                        <v-icon small>mdi-square-edit-outline</v-icon>
                        Edit User
                    </v-btn>
                    <v-btn class="mx-1" @click="cancelAction()" outlined text v-else>Cancel</v-btn>
                    <v-btn type="submit" color="primary" :loading="form.loading" :class="['mx-1', { disabled: isView }]">
                        <!-- <v-icon left v-if="action == 'invite-user'"> mdi-plus </v-icon> -->
                        {{ action == 'invite-user' ? 'Invite' : 'Save' }}
                    </v-btn>
                </v-card>
                <!-- End Upper Right Btns -->
            </v-app-bar>
            <v-container fluid class="pa-6">
                <v-row class="pl-4 pt-4">
                    <v-col cols="12" md="7" class="pb-0">
                        <!-- Start View User -->
                        <div class="card px-8 pt-5 pb-6 white rounded-lg" v-if="isView">
                            <h3 class="page-section-title mb-10">User Detail</h3>
                            <v-row>
                                <v-col cols="12" md="6" class="form-detail">
                                    <div>Email Address</div>
                                    <div>{{ form.email }}</div>
                                </v-col>

                                <v-col cols="12" md="6" class="form-detail">
                                    <div>Name</div>
                                    <div>{{ form.full_name }}</div>
                                </v-col>

                                <v-col cols="12" md="6" class="form-detail">
                                    <div>Role</div>
                                    <div>{{ (form.role || {}).name }}</div>
                                </v-col>

                                <v-col cols="12" md="6" class="form-detail">
                                    <!-- <template v-if="form.partner">
                                        <div>Partner</div>
                                        <div>{{ form.partner }}</div>
                                    </template> -->
                                    <template v-if="form.role && form.role.id == 'MERCHANT'">
                                        <div>Merchant</div>
                                        <div>{{ form.merchant.name }}</div>
                                    </template>
                                    <template v-else>
                                        <div>{{ form.role && form.role.id == 'PARTNER' ? 'Partner' : 'Company' }}</div>
                                        <div>{{ form.company }}</div>
                                    </template>
                                </v-col>

                                <v-col cols="12" md="6" class="form-detail">
                                    <div>Mobile number</div>
                                    <div>{{ form.mobile | formatPhoneNumber | formatMobileNumber }}</div>
                                </v-col>

                                <v-col cols="12" md="6" class="form-detail">
                                    <div>Last Access</div>
                                    <div>{{ form.last_logged_in_at | formatDate }}</div>
                                </v-col>

                                <v-col cols="12" md="6" class="form-detail status">
                                    <div>Status</div>
                                    <div class="mt-2">
                                        <small :class="['py-2 px-6 font-weight-medium status', form.status.toLowerCase()]">{{ form.status | uppercaseFirst }}</small>
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                        <!-- End View User -->

                        <!-- Start Create/Invite/Edit User -->
                        <div v-else>
                            <h3 class="page-section-title mb-8">User Detail</h3>

                            <v-row>
                                <v-col cols="12" md="12" class="py-0">
                                    <label for="email" class="field-label font-weight-medium">Email Address</label>
                                    <v-text-field
                                        v-model="form.email"
                                        :class="['mt-1 mb-6 pa-0', { 'is-invalid': errors.email }]"
                                        :error-messages="errors.email"
                                        placeholder="e.g. sample@email.com"
                                        autocomplete="nope"
                                        hide-details="auto"
                                        solo
                                        dense
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="6" class="py-0">
                                    <label for="name" class="field-label font-weight-medium">First Name</label>
                                    <v-text-field
                                        v-model="form.first_name"
                                        :class="['mt-1 mb-6 pa-0', { 'is-invalid': errors.first_name }]"
                                        :error-messages="errors.first_name"
                                        placeholder="eg. John"
                                        autocomplete="nope"
                                        hide-details="auto"
                                        solo
                                        dense
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6" class="py-0">
                                    <label for="name" class="field-label font-weight-medium">Last Name</label>
                                    <v-text-field
                                        v-model="form.last_name"
                                        :class="['mt-1 mb-6 pa-0', { 'is-invalid': errors.last_name }]"
                                        :error-messages="errors.last_name"
                                        placeholder="eg. Doe"
                                        autocomplete="nope"
                                        hide-details="auto"
                                        solo
                                        dense
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="12" class="py-0">
                                    <label for="company" class="field-label font-weight-medium">Role</label>
                                    <v-select
                                        v-model="selectedRole"
                                        :class="['mt-1 mb-6 pa-0', { 'is-invalid': errors.role_id }]"
                                        :error-messages="errors.role_id"
                                        item-text="text"
                                        item-value="value"
                                        :items="roleOptions"
                                        :loading="isRoleLoading"
                                        return-object
                                        autocomplete="nope"
                                        hide-details="auto"
                                        @change="changeRole"
                                        solo
                                        dense
                                    ></v-select>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="12" class="py-0">
                                    <div class="role-required-fields">
                                        <template v-if="selectedRole.value == 'PARTNER'">
                                            <label for="partner" class="field-label font-weight-medium">Partner</label>
                                            <!-- <v-text-field
                                                v-model="form.company"
                                                :class="['mt-1 mb-6 pa-0', { 'is-invalid': errors.company }]"
                                                :error-messages="errors.company"
                                                placeholder="Partner"
                                                autocomplete="nope"
                                                hide-details="auto"
                                                solo
                                                dense
                                            ></v-text-field> -->
                                            <v-select
                                                v-model="form.company"
                                                :class="['mt-1 mb-6 pa-0', { 'is-invalid': errors.company }]"
                                                :error-messages="errors.company"
                                                id="partner"
                                                :loading="isPartnerLoading"
                                                :items="partners"
                                                label="Select Partner"
                                                hide-details="auto"
                                                solo
                                                dense
                                            ></v-select>
                                        </template>

                                        <template v-if="selectedRole.value == 'MERCHANT'">
                                            <label for="merchant" class="field-label font-weight-medium">Merchant</label>
                                            <!-- <v-select
                                                v-model="selectedMerchant"
                                                :class="['mt-1 mb-6 pa-0', { 'is-invalid': errors.merchant_uuid }]"
                                                :error-messages="errors.merchant_uuid"
                                                item-text="text"
                                                item-value="value"
                                                :items="merchants"
                                                :loading="isMerchantLoading"
                                                return-object
                                                label="Select Merchant"
                                                hide-details="auto"
                                                solo
                                                dense
                                            ></v-select> -->
                                            <v-autocomplete
                                                ref="merchantsDropdown"
                                                :class="['mt-1 mb-6 pa-0', { 'is-invalid': errors.merchant_uuid }]"
                                                v-model="selectedMerchant"
                                                :items="merchantsDropdownList"
                                                :loading="isMerchantLoading"
                                                :search-input.sync="searchMerchant"
                                                :hide-no-data="isMerchantLoading"
                                                @blur="onBlurMerchantsDropdown"
                                                item-text="text"
                                                item-value="value"
                                                label="Select Merchant"
                                                placeholder="Select Merchant"
                                                solo
                                                dense
                                                clearable
                                                hide-details
                                                return-object
                                                prepend-inner-icon="search"
                                            >
                                                <template v-if="showInfiniteLoader" v-slot:append-item>
                                                    <div v-observe-visibility="reachedEndOfList" class="p-3 text-center mt-2">
                                                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                                                    </div>
                                                </template>
                                            </v-autocomplete>
                                        </template>

                                        <template v-if="selectedRole.value != 'MERCHANT' && selectedRole.value != 'PARTNER' && !isSelectedUserAdmin">
                                            <v-row class="my-0">
                                                <v-col cols="12" md="12" class="py-0">
                                                    <label for="company" class="field-label font-weight-medium">Company</label>
                                                    <v-text-field
                                                        v-model="form.company"
                                                        :class="['mt-1 mb-6 pa-0', { 'is-invalid': errors.company }]"
                                                        :error-messages="errors.company"
                                                        placeholder="Company"
                                                        autocomplete="nope"
                                                        hide-details="auto"
                                                        solo
                                                        dense
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </template>
                                    </div>
                                </v-col>
                            </v-row>
                            <v-row v-if="action == 'create' || action == 'edit'">
                                <v-col cols="12" md="12" class="py-0">
                                    <label for="mobile" class="field-label font-weight-medium">Mobile Number</label>
                                    <v-text-field
                                        v-model="form.mobile"
                                        @keypress="$validate.numbersOnly"
                                        :class="['mt-1 mb-6 pa-0', { 'is-invalid': errors.mobile }]"
                                        :error-messages="errors.mobile"
                                        placeholder="e.g. 09171234567"
                                        autocomplete="nope"
                                        hide-details="auto"
                                        solo
                                        dense
                                    ></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row v-if="action == 'create' || (action == 'edit' && userDetails.status != 'INVITED')">
                                <v-col cols="12" md="6" class="py-0">
                                    <label for="password" class="field-label font-weight-medium">Password</label>
                                    <v-text-field
                                        :type="showPassword ? 'text' : 'password'"
                                        v-model="form.password"
                                        :class="['mt-1 mb-6 pa-0', { 'is-invalid': errors.password }]"
                                        :error-messages="errors.password"
                                        hide-details="auto"
                                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                        @click:append="showPassword = !showPassword"
                                        autocomplete="nope"
                                        placeholder="Enter password"
                                        solo
                                        dense
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6" class="py-0">
                                    <label for="password" class="field-label font-weight-medium">Confirm Password</label>
                                    <v-text-field
                                        :type="showPasswordConfirmation ? 'text' : 'password'"
                                        v-model="form.password_confirmation"
                                        :class="['mt-1 mb-6 pa-0', { 'is-invalid': errors.password }]"
                                        :error-messages="errors.password"
                                        hide-details="auto"
                                        :append-icon="showPasswordConfirmation ? 'mdi-eye' : 'mdi-eye-off'"
                                        @click:append="showPasswordConfirmation = !showPasswordConfirmation"
                                        autocomplete="nope"
                                        placeholder="Enter password"
                                        solo
                                        dense
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="12" class="py-0">
                                    <label for="status" class="field-label font-weight-medium">Status</label>
                                    <v-select
                                        v-model="form.status"
                                        :class="['mt-1 mb-6 pa-0 font-weight-medium select-status', form.status.toLowerCase(), { 'is-invalid': errors.status, 'disabled-view': action == 'invite-user' }]"
                                        :error-messages="errors.status"
                                        :items="userStatuses"
                                        :loading="isStatusLoading"
                                        label="Select Status"
                                        hide-details="auto"
                                        solo
                                        dense
                                    >
                                        <template #selection="{ item }">
                                            <v-icon :class="item.value.toLowerCase()">mdi-circle-small</v-icon>
                                            {{ item.text }}
                                        </template>
                                    </v-select>
                                </v-col>
                            </v-row>
                        </div>
                        <!-- End Create/Invite/Edit User -->

                        <!-- Start Show Delete for View/Edit User -->
                        <div class="card d-flex align-center my-4 px-8 py-5 white rounded-lg" v-if="isView">
                            <span class="font-weight-bold">Delete this User</span>
                            <v-btn
                                color="error"
                                class="ml-auto float-right"
                                @click="
                                    confirmAction({
                                        action: 'delete',
                                        data: {
                                            id: $route.params.id
                                        }
                                    })
                                "
                                elevation="0"
                            >
                                Delete
                            </v-btn>
                        </div>
                        <!-- End Show Delete for View/Edit User -->
                    </v-col>

                    <v-col cols="12" md="5" class="pb-0">
                        <!-- Start Right Side Permissions; Readonly -->
                        <Permissions :role-id="selectedRole.value" page="users" />
                        <!-- End Right Side Permissions; Readonly -->
                    </v-col>
                </v-row>
            </v-container>
        </v-form>

        <AppModal :confirm-dialog="confirmDialog" :confirm-status-loading="confirmStatusLoading" @modalAction="modalAction" />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Permissions from '@/components/UserAccess/Permissions.vue';
import AppModal from '@/components/Core/AppModal.vue';

export default {
    name: 'UserAccessAction',
    components: {
        Permissions,
        AppModal
    },
    data() {
        return {
            action: '',
            from: '',
            form: {
                merchant: {},
                mobile: '',
                role: {},
                status: '',
                loading: false
            },
            isView: false,
            selectedRole: {},
            selectedMerchant: {},
            isPartnerLoading: true,
            isRoleLoading: true,
            isMerchantLoading: true,
            isStatusLoading: true,
            partner_id: '',
            showPassword: false,
            showPasswordConfirmation: false,
            isSelectedUserAdmin: true,
            adminRoles: ['DEV', 'ADMIN'],
            confirmDialog: { show: false, action: '', data: {}, status: '' },
            confirmStatusLoading: false,
            merchantsDropdownList: [],
            searchMerchant: '',
            timerId: null,
        };
    },
    computed: {
        ...mapGetters({
            userDetails: 'users/getUserDetails',
            userRole: 'users/getUserRole',
            merchants: 'options/getMerchants',
            roleOptions: 'options/getRoles',
            userStatuses: 'options/getUserStatuses',
            userInfo: 'authentication/getUserInfo'
        }),
        isCreate() {
            return 'cms_users-store' in this.userInfo.permissions && this.userInfo.permissions['cms_users-store'] === true && this.action != 'invite-user';
        },
        showInfiniteLoader() {
            const links = this.merchants.links || {};
            return links.next;
        },
        partners() {
            return this.formatFormItems(this.$store.getters['options/getPartners']);
        }
    },
    // Determine page and API calls
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.from = from.name;
            vm.onLoadData(to);
        });
    },
    watch: {
        // Determine page and API calls
        $route(to, from) {
            this.from = from.name;
            this.onLoadData(to);
        },
        // On fetch role options, set selected role
        roleOptions(value) {
            if (value.length != 0) {
                if (!this.selectedRole.value) {
                    if (this.action != 'view') {
                        this.selectedRole = value[0];
                    } else {
                        this.selectedRole = '';
                    }
                }

                if (this.selectedRole.value == 'MERCHANT') {
                    this.getMerchantsDropdown({ reset: true, name: this.selectedMerchant.text || '' });
                } else if (this.selectedRole.value == 'PARTNER') {
                    this.getPartners();
                }
            }
        },
        searchMerchant(to, from) {
            if ((!from && !to) || from === to) return;
            // const selectedAgent = this.merchantsDropdownList.find(agent => agent.text === to);
            // if (selectedAgent && selectedAgent.text === to) return;

            const alreadyExists = this.merchantsDropdownList.some(merchant => merchant.text === to);
            if (alreadyExists) return;

            this.isMerchantLoading = true;
            // this.lazyLoadScrollToTop();
            // if (to) this.isMerchantLoading = true;
            clearTimeout(this.timerId);
            // delay new call 500ms
            this.timerId = setTimeout(() => {
                // if (to) this.$api.cancelCurrentApiCall();
                // const page =  this.sitesMeta.current_page + 1;
                this.getMerchantsDropdown({ reset: true, name: to });
            }, 500);
        },
        // On user details, change selected role and set form
        userDetails(value) {
            if (value.role) {
                if (value.role.id) {
                    this.selectedRole = {
                        value: value.role.id,
                        text: value.role.name
                    };
                }

                if (value.merchant && value.merchant.id) {
                    let mobileTxt = value.mobile ? `[${value.mobile}] ` : '';

                    this.selectedMerchant = {
                        value: value.merchant.uuid,
                        text: `${mobileTxt}${value.merchant.name}`
                    };
                }

                if (this.selectedRole.value == 'MERCHANT') {
                    // this.getMerchantsDropdown({ reset: true, name: this.selectedMerchant.text || '' });
                } else if (this.selectedRole.value == 'PARTNER') {
                    this.getPartners();
                }
            }
            const form = {
                merchant: {},
                role: {},
                status: this.action == 'create' ? 'ACTIVE' : 'INVITED',
                loading: false
            };

            if (['edit', 'view'].includes(this.action)) {
                this.form = { ...form, ...value };
            } else {
                this.form = form;
            }
        }
    },
    methods: {
        // Determine page and API calls
        onLoadData(to) {
            Object.assign(this.form, {});
            this.action = this.$route.params.action;
            this.isView = false;

            if (this.action == 'create') {
                this.form.status = 'ACTIVE';
            } else if (this.action == 'invite-user') {
                this.form.status = 'INVITED';
            }

            switch (to.params.action) {
                case 'create':
                case 'invite-user':
                    this.getRoleOptions();
                    this.getUserStatusOptions();
                    break;
                case 'edit':
                    // If edit is not from view toggle
                    if (this.from != 'user-access-action') {
                        this.getUserDetails(true);
                    } else {
                        this.getRoleOptions();
                        this.getUserStatusOptions();
                    }
                    break;
                case 'view':
                    this.isView = true;
                    // If view is not from cancel edit toggle
                    if (this.from != 'user-access-action') {
                        this.getUserDetails();
                    }
                    break;
            }

            // User is not admin and is accessing create page
            // if (!this.isCreate && this.action == 'create') {
            //     this.$notify({
            //         group: 'main-notifications',
            //         type: 'error',
            //         duration: 5000,
            //         title: 'Content Management',
            //         text: 'This action is unauthorized.'
            //     });

            //     this.$router.push({ name: 'user-access' });
            // }
        },
        // On Edit User button click, enable editing of user details
        editDetails() {
            this.action = 'edit';
            this.$router.push(`/user-access/users/edit/${this.$route.params.id}`);
        },
        // On Cancel button click, determine route
        // If edit is from view, load view UI; Otherwise redirect to users datatable (Has issue w/ page refresh)
        cancelAction() {
            if (this.action == 'edit' /* && this.from == 'user-access-action'*/) {
                this.action = 'view';
                this.form = { ...this.userDetails };

                this.selectedRole = {
                    value: this.form.role ? this.form.role.id : '',
                    text: this.form.role ? this.form.role.name : ''
                };

                this.$router.push(`/user-access/users/view/${this.$route.params.id}`);
            } else {
                this.$router.push({ name: 'user-access' });
            }
        },
        // Modal confirmation
        confirmAction({ action, data }) {
            switch (action) {
                case 'delete':
                    data.modalTitle = `Are you sure you want to delete user ${this.form.full_name}?`;
                    data.modalDescription = 'Deleting will remove this account and all of the information of this account.';
                    this.confirmDialog = { show: true, action, data };
                    break;
            }
        },
        // Exec modal action
        modalAction({ action, data }) {
            data.confirmation = 0;

            switch (action) {
                case 'delete':
                    data.confirmation = 1;
                    this.deleteUser(data);
                    break;

                case 'cancel':
                    this.confirmDialog.show = false;
                    break;
            }
        },
        formatFormItems(formData) {
            let formatData = [];
            for (const [key, val] of Object.entries(formData)) {
                const obj = { text: key, value: val };
                if (!this.adminRoles.includes(this.userInfo.role.id)) {
                    if (key == this.userInfo.company) {
                        formatData.push(obj);
                    }
                } else {
                    formatData.push(obj);
                }
            }

            return formatData;
        },
        // On role Update
        changeRole() {
            this.form.selectedMerchant = {};
            this.form.company = '';

            if (this.selectedRole.value == 'MERCHANT') {
                this.getMerchantsDropdown({ reset: true });
            } else if (this.selectedRole.value == 'PARTNER') {
                this.getPartners();
            }
        },
        getPartners() {
            this.isPartnerLoading = true;
            this.$store
                .dispatch('options/fetchPartners')
                .then(() => {
                    this.isPartnerLoading = false;
                })
                .then(() => {
                    this.isPartnerLoading = false;
                });
        },
        // Get role dropdown;
        // If current account role is admin and user being edited is admin/dev role, filter admin/dev role; Otherwise get all except admin/dev role
        getRoleOptions() {
            let params = {};

            if (this.isCreate && this.isSelectedUserAdmin) {
                params = {
                    'filter_ids[0]': 'ADMIN',
                    'filter_ids[1]': 'DEV',
                    'filter_status[0]': 'ACTIVE'
                };
            } else {
                if (this.userInfo.role.id == 'PARTNER') {
                    params = {
                        'filter_ids[0]': 'PARTNER',
                        'filter_ids[1]': 'MERCHANT',
                        'filter_status[0]': 'ACTIVE'
                    };
                } else {
                    params = {
                        'exclude_ids[0]': 'ADMIN',
                        'exclude_ids[1]': 'DEV',
                        'filter_status[0]': 'ACTIVE'
                    };
                }
            }

            this.isRoleLoading = true;
            this.$store.commit('options/SET_ROLES', []);
            this.$store
                .dispatch('options/fetchRoles', {
                    config: {
                        params: params
                    }
                })
                .then(() => {
                    this.isRoleLoading = false;
                });
        },
        // Get merchant dropdown if selected role is merchant
        getMerchantsDropdown({ reset, page, name }) {
            this.isMerchantLoading = true;
            this.$store.commit('options/SET_MERCHANTS', []);

            const params = {
                'filter_classifications[]': 'PRIMARY',
                'filters[name]': name || undefined,
                sort_by: 'name',
                per_page: 10,
                page,
                order: 'asc'
            };
            if (this.userInfo.role.id == 'PARTNER') {
                params.partner = this.userInfo.company;
            }

            let select = [];

            // if (this.action == 'edit' && name) {
            //     select.push(this.selectedMerchant);
            // } else {
            // select.push({ value: '', text: 'Select Merchant' });
            // }

            this.$store
                .dispatch('options/fetchMerchants', {
                    config: {
                        params: params
                    },
                    select: select
                })
                .then(() => {
                    if (reset) this.merchantsDropdownList = [];
                    this.merchantsDropdownList.push(...this.merchants.data);

                    this.isMerchantLoading = false;
                });
        },
        // Get user status dropdown
        // Create Action = user should not have INVITED and LOCK options
        // Invite Action = user status should be INVITED
        // Status of current user being edited is INVITED = user status should be INVITED; Otherwise remove INVITED from dropdown
        getUserStatusOptions() {
            let params = {};

            switch (this.action) {
                case 'create':
                    params = {
                        'filter_ids[0]': 'ACTIVE',
                        'filter_ids[1]': 'INACTIVE'
                    };
                    break;
                case 'invite-user':
                    params = {
                        'filter_ids[0]': 'INVITED'
                    };
                    break;
                default:
                    if (this.form.status == 'INVITED') {
                        params = {
                            'filter_ids[0]': 'INVITED'
                        };
                    } else {
                        if (this.form.status != 'LOCKED') {
                            params = {
                                'exclude_ids[0]': 'INVITED',
                                'exclude_ids[1]': 'LOCKED'
                            };
                        } else {
                            params = {
                                'exclude_ids[0]': 'INVITED'
                            };
                        }
                    }
                    break;
            }

            this.isStatusLoading = true;
            this.$store.commit('options/SET_USER_STATUSES', []);
            this.$store
                .dispatch('options/fetchUserStatuses', {
                    config: {
                        params: params
                    }
                })
                .then(() => {
                    this.isStatusLoading = false;
                });
        },
        // Get user details
        getUserDetails(query = false) {
            this.$store.commit('users/SET_USER_DETAILS', {});
            this.$store
                .dispatch('users/findUser', {
                    id: this.$route.params.id,
                    config: {
                        params: {
                            'appends[0]': 'role',
                            'appends[1]': 'merchant'
                        }
                    }
                })
                .then((response) => {
                    const roleID = response.data.role ? response.data.role.id : '';
                    this.isSelectedUserAdmin = this.adminRoles.includes(roleID);
                    if (query) {
                        this.getRoleOptions();
                        this.getUserStatusOptions();
                    }

                    if (roleID == '' && !query) this.getRoleOptions();
                })
                .catch(() => {
                    // Unable to fetch user
                    this.$router.push({ name: 'user-access' });
                });
        },
        // On form submit
        onSubmit() {
            let dispatch;

            switch (this.action) {
                case 'create':
                    dispatch = 'users/createUser';
                    break;
                case 'invite-user':
                    dispatch = 'users/addUser';
                    break;
                case 'edit':
                    dispatch = 'users/updateUser';
                    break;
                default:
                    return;
            }

            const params = {
                email: this.form.email,
                first_name: this.form.first_name || undefined,
                last_name: this.form.last_name || undefined,
                role_id: this.selectedRole.value,
                company: this.form.company || undefined,
                mobile: this.form.mobile,
                status: this.form.status
            };

            // if (this.isCreate && this.isSelectedUserAdmin) {
            if (this.form.password != '') {
                params.password = this.form.password;
                params.password_confirmation = this.form.password_confirmation;
            }
            // }

            if (this.selectedRole.value == 'MERCHANT') {
                params.merchant_uuid = this.selectedMerchant.value;
                // const merchant = Object.values(this.merchants).find((merchant) => {
                //     return merchant.value == this.selectedMerchant.value;
                // });

                // params.company = merchant?.company || '';
            }

            this.form.loading = true;
            this.$store
                .dispatch(dispatch, {
                    id: this.$route.params.id,
                    config: {
                        params: params
                    }
                })
                .then((response) => {
                    this.form.loading = false;
                    this.notification({ type: 'success', message: response.message });

                    // If has user id
                    if (this.$route.params.id) {
                        this.action = 'view';
                        this.$router.push(`/user-access/users/view/${this.$route.params.id}`);
                        this.getUserDetails();
                    } else {
                        // Newly added user
                        this.$router.push({ name: 'user-access' });
                    }
                })
                .catch(() => {
                    this.form.loading = false;
                });
        },
        // Delete user
        deleteUser(data) {
            this.confirmStatusLoading = true;

            this.$store
                .dispatch('users/deleteUser', {
                    id: data.id,
                    config: {
                        params: {
                            confirmation: data.confirmation
                        }
                    }
                })
                .then((response) => {
                    this.notification({ type: 'success', message: response.message });
                    this.confirmStatusLoading = false;
                    this.$router.push({ name: 'user-access' });
                })
                .catch(() => {
                    this.confirmStatusLoading = false;
                });
        },
        // Infinite Load
        reachedEndOfList(reached) {
            if (reached && !this.isMerchantLoading && this.merchantsDropdownList?.length) {
                const page = this.merchants.meta.current_page + 1;
                this.getMerchantsDropdown({ page, name: this.searchMerchant || '' });
            }
        },
        onBlurMerchantsDropdown() {
            this.searchMerchant = this.selectedMerchant ? this.selectedMerchant.text : '';
            // this.lazyLoadScrollToTop();
        }
        // lazyLoadScrollToTop() {
        //     this.$refs.merchantsDropdown.$refs.menu.$refs.content.scrollTop = 0;
        // }
    }
};
</script>

<style lang="scss" scoped>
.status {
    border-radius: 4px;
}

.select-status {
    .active {
        color: #27ae60;
    }
    .inactive {
        color: #7d7d7d;
    }
    .locked {
        color: #d43b1b;
    }
    .invited {
        color: #f2be42;
    }
}
</style>
